import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _identity from "lodash/identity";
import _noop from "lodash/noop";
import { getMCCommand } from '@datacamp/dc-languages-config';
import multiplexerClient from '@datacamp/multiplexer-client';
import { createBrowserHistory } from 'history';
import qs from 'qs';
import { getEndpoints } from './endpoints';
class MultiplexerSessionManager {
  constructor(user, type, environment, exercise, outputsCb, forceNew) {
    this.type = type;
    this.exercise = exercise;
    _defineProperty(this, "multiplexerUrl", void 0);
    _defineProperty(this, "client", void 0);
    _defineProperty(this, "unsubscribeToStatus", _noop);
    _defineProperty(this, "status", multiplexerClient.AsyncSession.STATUS.NONE);
    _defineProperty(this, "lastSubmittedCode", '');
    _defineProperty(this, "featureFlags", {
      cx_ide_exercise_diff_solution_flow: 'on'
    });
    const {
      MULTIPLEXER_URL
    } = getEndpoints(environment);
    this.multiplexerUrl = MULTIPLEXER_URL;
    const history = createBrowserHistory();
    const {
      image,
      runtime_config: runtimeConfig,
      shared_image: sharedImage
    } = qs.parse(history.location.search, {
      ignoreQueryPrefix: true
    });
    this.client = new multiplexerClient.AsyncSession({
      authentication_token: user.authenticationToken,
      email: user.email
    }, {
      flattenOutputs: false,
      initCommand: {
        code: exercise.sampleCode,
        command: 'init',
        featureFlags: this.featureFlags,
        pec: exercise.preExerciseCode,
        sct: exercise.sct,
        solution: exercise.solution,
        type: this.type
      },
      keepAlive: true,
      language: exercise.language,
      multiplexerUrl: this.multiplexerUrl,
      retryOptions: {
        delay: 1000,
        nbOfRetry: 10
      },
      startOptions: {
        course_id: this.exercise.courseId,
        force_new: forceNew,
        image,
        runtime_config: runtimeConfig || exercise.runtimeConfig,
        shared_image: sharedImage
      }
    });
    this.client.subscribeToOutputs(_identity, outputs => outputsCb(outputs, this.lastSubmittedCode));
  }
  start() {
    this.client.start();
  }
  stop() {
    this.client.unsubscribeAll();
    this.unsubscribeToStatus();
    this.client.stopPolling();
  }
  submitChoice(choice) {
    if (choice === undefined) {
      return;
    }
    this.input('submit', getMCCommand(this.exercise.language, choice + 1));
  }
  subscribeToStatus(cb) {
    this.unsubscribeToStatus = this.client.subscribe(_ref => {
      let {
        status: newStatus
      } = _ref;
      if (this.status !== newStatus) {
        this.status = newStatus;
        cb(newStatus);
      }
    });
  }
  view(tableName) {
    this.client.input({
      code: '',
      command: 'view',
      featureFlags: this.featureFlags,
      pec: this.exercise.preExerciseCode,
      sct: this.exercise.sct,
      solution: this.exercise.solution,
      tableName,
      type: this.type
    });
  }
  input(command) {
    let code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    this.lastSubmittedCode = code;
    this.client.input({
      code,
      command,
      featureFlags: this.featureFlags,
      pec: this.exercise.preExerciseCode,
      sct: this.exercise.sct,
      solution: this.exercise.solution,
      type: this.type
    });
  }
}
export const MULTIPLEXER_STATUS = multiplexerClient.AsyncSession.STATUS;
export const isMultiplexerSessionBroken = status => status === MULTIPLEXER_STATUS.BROKEN;
export const isMultiplexerSessionReady = status => status === MULTIPLEXER_STATUS.READY;
export default MultiplexerSessionManager;